import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import { findIndex } from 'lodash';
import MarkupBundle from '../models/MarkupBundle';

const initialState = {
    isFetching: false,
    isFetched: false,
    markupBundles: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    detail: {
        markupBundle: new MarkupBundle()
    },
    errorCode: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.MARKUP_BUNDLE_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.MARKUP_BUNDLE_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                markupBundles: action.markupBundle.result,
                // pageSize: action.markupBundle.pageSize,
                // pageIndex: action.markupBundle.pageIndex,
                // totalCount: action.markupBundle.totalCount,
                // totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize))
            };
        case Types.MARKUP_BUNDLE_LIST_FAIL:
            return { ...state, isFetching: false, isFetched: true, markupBundles: [] };
        case Types.MARKUP_BUNDLE_DETAIL_ACTION:
            return { ...state, isFetching: true, detail: initialState.detail };
        case Types.MARKUP_BUNDLE_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                detail: {
                    markupBundle: action.markupBundle
                }
            };
        case Types.MARKUP_BUNDLE_DETAIL_FAIL:
            return { ...state, isFetching: false, isFetched: true };
        case Types.MARKUP_BUNDLE_DETAIL_DELETE_ACTION:
            return { ...state, isFetching: true };
        case Types.MARKUP_BUNDLE_DETAIL_UPDATE_ACTION:
            return { ...state, isFetching: true, errorCode: null };
        case Types.MARKUP_BUNDLE_UPDATE_FAIL:
            return { ...state, isFetching: false, isFetched: false, errorCode: action.error };
        default: return state
    }
}